import React, { useEffect, useState } from "react"
import { useParams, withRouter, useHistory } from "react-router-dom"
import { useSelector, connect } from "react-redux"

import {
  Col,
  UncontrolledTooltip,
  Table,
  Button,
  Row,
  Label,
  Input,
  Nav,
  // Badge
} from "reactstrap"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import { isEmpty, get } from "lodash"
import * as quotationAction from "../../store/cXVvdGF0/actions"
import { CSVExport } from "react-bootstrap-table2-toolkit"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import api from "helpers/Api"
import moment from "moment"
import Select from "react-select"
import { ToastContainer, toast } from "react-toastify"
import OverallDeliverables from "./OverallDeliverables"
import "./styles.scss"

const EcDeliverableDetails = (props) => {
  const { dispatch, searchBarStyle, modeMenu } = props
  let { id } = useParams()
  const { SearchBar } = Search
  const Id = {
    leadId: id,
    operationMode: "PRE",
    status: "active",
  }
  console.log(Id, "id")
  console.log(modeMenu, "modeMenu")
  //tab
  const [deliverTab, setDeliverTab] = useState("Pre Deliverables")
  useEffect(() => {
    if (deliverTab === "Pre Deliverables") {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
      dispatch(quotationAction.loadDeliverableEmployee())
      dispatch(quotationAction.loadProcessStatus())
    }
  }, [deliverTab])
  const history = useHistory()

  console.log(history, "history")

  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )
  const {
    ec_deliverable_details = [],
    deliver_employeelist = [],
    processStatus,
  } = quotationUpdate

  console.log(quotationUpdate, "update is")
  const empId = localStorage.getItem("empId")

  console.log(empId, "employee Id")
  //date format

  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
  const [productData, setProductData] = useState({
    notes: "",
  })

  const handleNotes = (e) => {
    setProductData({ ...productData, [e.target.name]: e.target.value })
  }

  const [teamData, setTeamData] = useState({
    note: "",
  })

  const handleTeam = (e) => {
    setTeamData({ ...teamData, [e.target.name]: e.target.value })
  }

  const [multiProductEmployee, setMultiProductEmployee] = useState([])
  const [multiTeamEmployee, setMultiTeamEmployee] = useState([])

  const [multiProductData, setMultiProductData] = useState({
    note: "",
  })
  const handleMultiProduct = (e) => {
    setMultiProductData({
      ...multiProductData,
      [e.target.name]: e.target.value,
    })
  }
  const [multiTeamData, setMultiTeamData] = useState({
    note: "",
  })
  const handleMultiTeam = (e) => {
    setMultiTeamData({ ...multiTeamData, [e.target.name]: e.target.value })
  }

  const [employee, setEmployee] = useState([])
  const [teamEmployee, setTeamEmployee] = useState([])
  const [productAssignModal, setProductAssignModal] = useState(false)
  const [teamAssignModal, setTeamAssignModal] = useState(false)

  const [productAssignData, setProductAssignData] = useState("")
  const [teamAssignData, setTeamAssignData] = useState("")
  //product and team assign
  const [productAssignDetails, setProductAssignDetails] = useState([])
  const [productSubmitButton, setProductSubmitButton] = useState(false)

  const [teamAssignDetails, setTeamAssignDetails] = useState([])
  const [teamSubmitButton, setTeamSubmitButton] = useState(false)

  const [multiProductModal, setMultiProductModal] = useState(false)
  const [multiTeamModal, setMultiTeamModal] = useState(false)

  // const [crmModalAttachment, setCrmModalAttachment] = useState([])
  //employee options

  const employeeList =
    !isEmpty(deliver_employeelist) &&
    deliver_employeelist.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        companyName: employee.companyName,
        branchName: employee.branchName,
        branchId: employee.branchId,
        departmentName: employee.departmentName,
        departmentId: employee.departmentId,
        designationName: employee.designationName,
        designationId: employee.designationId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.companyName = element.companyName
        obj.branchId = element.branchId
        obj.branchName = element.branchName
        obj.departmentId = element.departmentId
        obj.departmentName = element.departmentName
        obj.designationId = element.designationId
        obj.designationName = element.designationName
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }
  //process status options
  const processStatusOptions =
    !isEmpty(processStatus) && processStatus.length > 0
      ? processStatus.map((data) => {
          return {
            colorCode: data.colorCode,
            label: data.processStatus,
            value: data.processStatusId,
          }
        })
      : []
  const employeeOptions = createOptions(employeeList)

  const [processStatusModal, setProcessStatusModal] = useState(false)

  //Edit assign team lead
  const editTeamAssign = (data) => {
    const teamEmployeeDetails = !isEmpty(data)
      ? data.map((team) => {
          return {
            label: team.empCode.concat(" - ", team.name),
            value: team._id,
          }
        })
      : []
    setTeamEmployee(teamEmployeeDetails)
  }

  //Edit product lead
  const editProductAssign = (data) => {
    const productDetails = !isEmpty(data)
      ? data.map((team) => {
          return {
            label: team.empCode.concat(" - ", team.name),
            value: team._id,
          }
        })
      : []
    setEmployee(productDetails)
  }
  //datatable
  const deliverableData = ec_deliverable_details
  //crm assign
  //crm assign

  const [crmData, setCrmData] = useState({
    notes: "",
  })

  const handleCrmNotes = (e) => {
    setCrmData({ ...crmData, [e.target.name]: e.target.value })
  }

  const [crmEmployee, setCrmEmployee] = useState([])
  const [multiEmployee, setMultiEmployee] = useState([])
  //reset
  const [multiCrmData, setMultiCrmData] = useState({
    note: "",
  })
  const handleMultiNotes = (e) => {
    setMultiCrmData({ ...multiCrmData, [e.target.name]: e.target.value })
  }
  const [crmAssignModal, setCrmAssignModal] = useState(false)
  const [crmAssignData, setCrmAssignData] = useState("")
  console.log(crmAssignData)
  const [multiCrmModal, setMultiCrmModal] = useState(false)
  const [crmAssignDetails, setCrmAssignDetails] = useState([])
  const [crmAssignButton, setCrmAssignButton] = useState(false)
  //tat attachment
  const [tatAttachment, setTatAttachment] = useState([])

  const tatAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      setTatAttachment(file)
      var teamUploadValue = tatAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setTatAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  const [tatModal, setTatModal] = useState(false)
  const [tatUpdate, setTatUpdate] = useState(false)
  const [tatView, setTatView] = useState(false)

  //tatmodal
  const [tatData, setTatData] = useState({
    tatDate: "",
    link: "",
    remarks: "",
  })

  const handleTatChange = (e) => {
    setTatData({
      ...tatData,
      [e.target.name]: e.target.value,
    })
  }
  const [tatDetails, setTatDetails] = useState("")
  const [operationHistoryDetails, setOperationHistoryDetails] = useState("")
  const [processHistoryDetails, setProcessHistoryDetails] = useState("")

  //crm Attachment
  const [crmAttachmentModal, setCrmAttachmentModal] = useState(false)
  const [crmAttachmentsDetails, setCrmAttachmentsDetails] = useState("")
  let slNo = 0
  //Deliverable Data Table section
  const deliverDataTable = !isEmpty(deliverableData)
    ? deliverableData.map((deliver, index) => {
        const deliverId = get(deliver, "_id", "")
        const deliverStatus = get(deliver, "status", "")
        const deliverQuantity = get(deliver, "quantity", "No quantity")
        const deliverActualPrice = get(deliver, "actualPrice", "No actualPrice")
        const deliverQuotePrice = get(deliver, "quotePrice", "No quotePrice")
        // const deliverDiscount = get(deliver, "discount", "No discount")
        const deliverUpselling = get(deliver, "upselling", "No upselling")
        const deliverFinalAmount = get(deliver, "finalAmount", "No price")
        const deliverableType = get(
          deliver,
          "deliverableName",
          "No deliverableType"
        )
        const deliverProduct = get(deliver, "productName", "No product Name")
        const deliverCommercial = get(deliver, "commercialMode", "No price")
        const deliveryMode = get(deliver, "deliveryModeName", "No deliver")
        const crmAttachments = !isEmpty(deliver.crmAttachments)
          ? deliver.crmAttachments.map((m) => m).join()
          : ""

        const employeeArray =
          !isEmpty(deliver.assignedTeamlead) &&
          deliver.assignedTeamlead.length > 0 &&
          deliver.assignedTeamlead
            .map((m) => {
              const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
              return empName
            })
            .filter(Boolean)
        const productLeadName =
          employeeArray.length > 0 ? employeeArray.join() : "--"

        const teamArray =
          !isEmpty(deliver.assignedEmployee) &&
          deliver.assignedEmployee.length > 0 &&
          deliver.assignedEmployee
            .map((m) => {
              const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
              return empName
            })
            .filter(Boolean)
        const teamName = teamArray.length > 0 ? teamArray.join() : ""

        const colorCode =
          !isEmpty(processStatusOptions) &&
          processStatusOptions.length > 0 &&
          processStatusOptions.find(
            (_) => _.value === deliver.productionProcessStatus
          )?.colorCode
        slNo = slNo + 1
        return {
          _id: deliverId,
          index: index,
          leadId: deliver.leadId,
          eventId: deliver.eventId,
          crmName: deliver.crmName,
          sNo: slNo,
          status: deliverStatus,
          colorCode: colorCode,
          assignEmployee:
            !isEmpty(deliver.assignedEmployee) &&
            deliver.assignedEmployee.length > 0
              ? teamName
              : "Assign Team",
          assignTeam:
            !isEmpty(deliver.assignedTeamlead) &&
            deliver.assignedTeamlead.length > 0
              ? productLeadName
              : "Assign Product Lead",

          eventNo:
            !isEmpty(deliver) && deliver.eventNo && deliver.eventNo.length > 0
              ? deliver.eventNo.join(" , ")
              : deliver.eventNo,
          eventName:
            !isEmpty(deliver) &&
            deliver.eventName &&
            deliver.eventName.length > 0
              ? deliver.eventName.join(" , ")
              : deliver.eventName,
          deliverableType: deliverableType,
          deliverableId: deliver.deliverableId,
          deliverableName: deliver.deliverableName,
          productionId: deliver.oprationId,
          leadDeliverableId: deliver.leadDeliverableId,
          specialInstructions: (
            <div>
              <Button
                className="btn btn-info"
                onClick={() => {
                  setInstructionsDetails(deliver.specialInstruction)
                  setInstructionsModal(true)
                }}
                disabled={modeMenu === "EventComplete" ? true : false}
              >
                Instructions
              </Button>
            </div>
          ),
          productId: deliver.productId,
          productName: deliverProduct,
          productLeadName: !isEmpty(deliver.productLeadName)
            ? deliver.productLeadName
            : "--",
          endWorkerName: deliver.endWorkerName ? deliver.endWorkerName : "--",
          crmRemarks: !isEmpty(deliver.crmRemark) ? deliver.crmRemark : "--",
          crmAttachments: deliver.crmAttachments,
          tatDate: !isEmpty(deliver.tat)
            ? moment(deliver.tat).format(dateFormat)
            : "--",
          overAllStatus: !isEmpty(deliver.overAllStatus)
            ? deliver.overAllStatus
            : "--",
          attachment: crmAttachments ? crmAttachments : "--",
          remarks: !isEmpty(deliver.deliverableRemarks)
            ? deliver.deliverableRemarks
            : "",
          commercialMode: deliverCommercial,
          quantity: deliverQuantity,
          actualPrice: deliverActualPrice,
          quotePrice: deliverQuotePrice,
          discount: deliver.discount,
          count: deliver.count,
          sheet: deliver.sheetLength,
          length: deliver.length,
          finalAmount: deliverFinalAmount,
          upselling: deliverUpselling,
          deliveryModeName: deliveryMode,
          deliverabletype: deliver.deliverableType
            ? deliver.deliverableType
            : "",
          deliveryModeId: deliver.deliveryModeId,
          key: index,
          productionStatus: deliver.productionStatus,
          link: deliver.link ? deliver.link : "--",
          operationStatus: deliver.productionProcessStatusName,
          assignedEmployee: deliver.assignedEmployee,
          assignedTeam: deliver.assignedTeamlead,
          operationHistory: !isEmpty(deliver.operationalHistory)
            ? deliver.operationalHistory
            : [],
          processHistory: !isEmpty(deliver.processHistory)
            ? deliver.processHistory
            : [],
        }
      })
    : []

  useEffect(() => {
    if (productAssignDetails.length > 0) {
      setProductSubmitButton(true)
    } else {
      setProductSubmitButton(false)
    }
  }, [productAssignDetails])

  useEffect(() => {
    if (teamAssignDetails.length > 0) {
      setTeamSubmitButton(true)
    } else {
      setTeamSubmitButton(false)
    }
  }, [teamAssignDetails])

  useEffect(() => {
    if (crmAssignDetails.length > 0) {
      setCrmAssignButton(true)
    } else {
      setCrmAssignButton(false)
    }
  }, [crmAssignDetails])

  const deliverArrayDetails = !isEmpty(deliverDataTable)
    ? deliverDataTable.filter((data) => data !== undefined)
    : []
  console.log(deliverArrayDetails, "deliverArray")

  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "productName",
      text: "Product Name",
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "deliverableType",
      text: "Deliverable Type",
      csvExport: true,
      editable: false,
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "quantity",
      text: "Quantity",
      sort: true,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "specialInstructions",
      text: "Special Instructions",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "crmName",
      text: "Crm Name",
      editable: false,
      formatter: (cellContent, row) => {
        console.log(row)
        return (
          <>
            <div className="d-flex flex-row align-items-center">
              <Button
                className="btn btn-warning text-nowrap"
                onClick={() => {
                  setCrmAssignModal(true)
                  setCrmAssignData(row)
                  handleClearModal()
                }}
              >
                {row.crmName ? row.crmName : "CRM Assign"}
              </Button>
              <div style={{ marginLeft: "10px" }}>
                <Input
                  type="checkbox"
                  checked={crmAssignDetails.some(
                    (item) => item.leadId === row.leadId
                  )}
                  style={{ width: "15px", height: "15px" }}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !crmAssignDetails.find(
                        (item) => item.leadId === row.leadId
                      )
                    ) {
                      setCrmAssignDetails([...crmAssignDetails, row])
                    } else {
                      setCrmAssignDetails(
                        crmAssignDetails.filter(
                          (item) => item.leadId !== row.leadId
                        )
                      )
                    }
                    const anyChecked = crmAssignDetails.some(
                      (item) => item.leadId !== row.leadId
                    )
                    setCrmAssignButton(anyChecked)
                  }}
                />
              </div>
            </div>
          </>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "productLeadName",
      text: "Product Lead name",
      editable: false,
      formatter: (cellContent, row) => {
        console.log(row)
        return (
          <>
            <div className="d-flex flex-row align-items-center">
              <Button
                className="btn btn-info text-nowrap"
                onClick={() => {
                  setProductAssignModal(true)
                  handleClearModal()
                  setProductAssignData(row)
                  if (
                    !isEmpty(row.assignedTeam) &&
                    row.assignedTeam.length > 0
                  ) {
                    editProductAssign(row.assignedTeam)
                  }
                }}
                disabled={modeMenu === "EventComplete" ? true : false}
              >
                {row.assignTeam}
              </Button>

              <div style={{ marginLeft: "10px" }}>
                <Input
                  type="checkbox"
                  checked={productAssignDetails.some(
                    (item) => item.leadDeliverableId === row.leadDeliverableId
                  )}
                  style={{ width: "15px", height: "15px" }}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !productAssignDetails.find(
                        (item) =>
                          item.leadDeliverableId === row.leadDeliverableId
                      ) &&
                      isEmpty(teamAssignDetails)
                    ) {
                      setProductAssignDetails([...productAssignDetails, row])
                    } else {
                      setProductAssignDetails(
                        productAssignDetails.filter(
                          (item) =>
                            item.leadDeliverableId !== row.leadDeliverableId
                        )
                      )
                    }
                    const anyChecked = productAssignDetails.some(
                      (item) => item.leadDeliverableId !== row.leadDeliverableId
                    )
                    setProductSubmitButton(anyChecked)
                  }}
                  className={
                    modeMenu === "EventComplete" ? "disabled-button" : ""
                  }
                />
              </div>
            </div>
          </>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },

    {
      dataField: "endWorkerName",
      text: "Team Name",
      editable: false,
      formatter: (cellContent, row) => {
        console.log(row)
        return (
          <>
            <div className="d-flex flex-row align-items-center">
              <Button
                className="btn btn-warning text-nowrap"
                onClick={() => {
                  setTeamAssignModal(true)
                  setTeamAssignData(row)
                  handleClearModal()
                  if (
                    !isEmpty(row.assignedEmployee) &&
                    row.assignedEmployee.length > 0
                  ) {
                    editTeamAssign(row.assignedEmployee)
                  }
                }}
                disabled={modeMenu === "EventComplete" ? true : false}
              >
                {row.assignEmployee}
              </Button>

              <div style={{ marginLeft: "10px" }}>
                <Input
                  type="checkbox"
                  checked={teamAssignDetails.some(
                    (item) => item.leadDeliverableId === row.leadDeliverableId
                  )}
                  style={{ width: "15px", height: "15px" }}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !teamAssignDetails.find(
                        (item) =>
                          item.leadDeliverableId === row.leadDeliverableId
                      ) &&
                      isEmpty(productAssignDetails)
                    ) {
                      setTeamAssignDetails([...teamAssignDetails, row])
                    } else {
                      setTeamAssignDetails(
                        teamAssignDetails.filter(
                          (item) =>
                            item.leadDeliverableId !== row.leadDeliverableId
                        )
                      )
                    }
                    const anyChecked = teamAssignDetails.some(
                      (item) => item.leadDeliverableId !== row.leadDeliverableId
                    )
                    setTeamSubmitButton(anyChecked)
                  }}
                  className={
                    modeMenu === "EventComplete" ? "disabled-button" : ""
                  }
                />
              </div>
            </div>
          </>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "tatDate",
      text: "TAT Date",
      headerStyle: {
        minWidth: "170px",
      },
    },

    {
      dataField: "link",
      text: "Deliverable Link",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "crmRemarks",
      text: "Deliverable Remarks",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "crmAttachments",
      text: "Deliverable Attachment",
      editable: false,
      hidden: false,
      formatter: (cellContent, row) => {
        const attachCount =
          !isEmpty(row.crmAttachments) && row.crmAttachments.length > 0
            ? row.crmAttachments.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(row.crmAttachments) ? (
                  <a
                    onClick={() => {
                      setCrmAttachmentModal(true)
                      setCrmAttachmentsDetails(row.crmAttachments)
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },
      csvExport: true,
      headerStyle: {
        minWidth: "185px",
      },
    },

    {
      dataField: "history",
      text: "Deliverable Update History",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row align-items-center">
            <Button
              className="btn btn-warning"
              onClick={() => {
                setTatModal(true)
                setTatUpdate(true)
                setTatView(false)
                setTatDetails(row)
                setTatData({
                  ...tatData,
                  tatDate: "",
                  link: "",
                  remarks: "",
                })
                setTatAttachment([])
              }}
            >
              Update
            </Button>
            <div style={{ marginLeft: "10px" }}>
              <i
                className="fas fa-eye text-info fs-5"
                onClick={() => {
                  setTatModal(true)
                  setTatUpdate(false)
                  setTatView(true)
                  setOperationHistoryDetails(row.operationHistory)
                }}
              ></i>
            </div>
          </div>
        )
      },
      headerStyle: {
        minWidth: "205px",
      },
    },
    {
      dataField: "overAllStatus",
      text: "Over All Status",
      editable: false,
      headerStyle: {
        minWidth: "170px",
      },
    },

    {
      dataField: "operationStatus",
      text: "Operation Status",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              {!isEmpty(row.operationStatus) ? (
                <button
                  style={{
                    background: row.colorCode,
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                    padding: "2px",
                    borderRadius: "4px",
                  }}
                >
                  {row.operationStatus}
                </button>
              ) : (
                "--"
              )}
            </Col>
            <Col md="2" lg="2" sm="2">
              <i
                className="fas fa-eye text-info fs-5"
                onClick={() => {
                  setProcessStatusModal(true)
                  setProcessHistoryDetails(row.processHistory)
                }}
              ></i>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  //download feature in data table
  const { ExportCSVButton } = CSVExport
  // pagination options
  const options = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  //Modal Section
  const [instructionsModal, setInstructionsModal] = useState(false)
  const [instructionsDetails, setInstructionsDetails] = useState("")

  //Modal section end

  //Product assign section

  const productSubmit = () => {
    const deliverName = productAssignData.deliverableName
    const deliverValue =
      deliverName === "PHOTO" ? 1 : deliverName === "VIDEO" ? 2 : ""
    const product_details = {
      menuMode: deliverValue,
      employeeId: employee.value,
      notes: productData.notes,
      attachments: attachmentModalFile,
      leadAssignDetail: [
        {
          leadId: productAssignData.leadId,
          leadDelivarableId: productAssignData.leadDeliverableId,
          leadEventId: productAssignData.eventId,
        },
      ],
    }
    console.log(product_details, "productdetails")
    dispatch(quotationAction.addProductAssign(product_details))
    setTimeout(() => {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
      toast.success("Product Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  console.log(productAssignDetails, "productAssignDetails")
  const multiProductSubmit = () => {
    const product_details = {
      menuMode: 1,
      employeeId: multiProductEmployee.value,
      notes: multiProductData.note,
      attachments: multiProductFile,
      leadAssignDetail: productAssignDetails.map((data) => {
        return {
          leadId: data.leadId,
          leadDelivarableId: data.leadDeliverableId,
          leadEventId: data.eventId,
        }
      }),
    }
    console.log(product_details, "productdetails")
    dispatch(quotationAction.addProductAssign(product_details))
    setTimeout(() => {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
      toast.success("Product Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setProductAssignDetails([])
      toast.success("Multiple Product Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setMultiProductModal(false)
    }, 1000)
  }
  console.log(productAssignData, "productAssignData")

  //Team assigne section

  const teamSubmit = () => {
    const deliverName = teamAssignData.deliverableName
    const deliverValue =
      deliverName === "PHOTO" ? 1 : deliverName === "VIDEO" ? 2 : ""
    const team_details = {
      leadAssignDetail: [
        {
          leadId: teamAssignData.leadId,
          leadDelivarableId: teamAssignData.leadDeliverableId,
          leadEventId: teamAssignData.eventId,
        },
      ],
      menuMode: deliverValue,
      employeeId: teamEmployee.value,
      notes: teamData.note,
      attachments: uploadModalInput,
      assignedBy: empId,
    }
    console.log(team_details, "teamdetails")
    dispatch(quotationAction.addTeamAssign(team_details))
    setTimeout(() => {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
      toast.success("Team Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  const teamMultipleSubmit = () => {
    const team_details = {
      menuMode: 1,
      employeeId: multiTeamEmployee.value,
      notes: multiTeamData.note,
      attachment: multiTeamFile,
      assignedBy: empId,
      leadAssignDetail: teamAssignDetails.map((data) => {
        return {
          leadId: data.leadId,
          leadDelivarableId: data.leadDeliverableId,
          leadEventId: data.eventId,
        }
      }),
    }
    console.log(team_details, "teamdetails")
    dispatch(quotationAction.addTeamAssign(team_details))
    setTimeout(() => {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
      setTeamAssignDetails([])
      toast.success("Team Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setMultiTeamModal(false)
    }, 1000)
  }
  const handleClearModal = () => {
    setEmployee([])
    setTeamEmployee([])
    setMultiProductEmployee([])
    setMultiTeamEmployee([])
    setProductData({ ...productData, notes: "" })
    setTeamData({ teamData, note: "" })
    setMultiProductData({ ...multiProductData, note: "" })
    setMultiTeamData({ ...multiTeamData, note: "" })
    setUploadModalInput([])
    setAttachmentModalFile([])
    setMultiProductFile([])
    setMultiTeamFile([])
    setAttachFileLength("")
    setAttachFileName("")
    setFileLength("")
    setFileName("")
    setProductFileLength("")
    setProductFileName("")
    setTeamFileLength("")
    setTeamFileName("")
    setCrmData({
      ...crmData,
      notes: "",
    })
    setCrmEmployee([])
    setMultiCrmData({
      ...multiCrmData,
      note: "",
    })
    setMultiEmployee([])
  }

  const [uploadModalInput, setUploadModalInput] = useState([])
  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")

  const uploadModalChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setUploadModalInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadModalInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadModalInput(teamUploadValue)
          }
        })
      }
    }
  }
  const [attachmentModalFile, setAttachmentModalFile] = useState([])
  const [attachFileName, setAttachFileName] = useState("")
  const [attachFileLength, setAttachFileLength] = useState("")
  const productUploadChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setAttachmentModalFile(e.target.files)
      var file = e.target.files
      setAttachFileName(file[0].name)
      setAttachFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = attachmentModalFile
      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setAttachmentModalFile(teamUploadValue)
          }
        })
      }
    }
  }

  const [multiProductFile, setMultiProductFile] = useState([])
  const [productFileName, setProductFileName] = useState("")
  const [productFileLength, setProductFileLength] = useState("")
  const multiProductChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setMultiProductFile(e.target.files)
      var file = e.target.files
      setProductFileName(file[0].name)
      setProductFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiProductFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiProductFile(teamUploadValue)
          }
        })
      }
    }
  }
  const [multiTeamFile, setMultiTeamFile] = useState([])
  const [teamFileName, setTeamFileName] = useState("")
  const [teamFileLength, setTeamFileLength] = useState("")
  const multiTeamChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setMultiTeamFile(e.target.files)
      var file = e.target.files
      setTeamFileName(file[0].name)
      setTeamFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiTeamFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiTeamFile(teamUploadValue)
          }
        })
      }
    }
  }

  const [uploadCrmInput, setUploadCrmInput] = useState([])
  const [fileCrmName, setFileCrmName] = useState("")
  const [fileCrmLength, setFileCrmLength] = useState("")

  const uploadCrmChange = async (e) => {
    if (e.target.files) {
      setUploadCrmInput(e.target.files)
      var file = e.target.files
      setFileCrmName(file[0].name)
      setFileCrmLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadCrmInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadCrmInput(teamUploadValue)
          }
        })
      }
    }
  }

  const [uploadMultiCrmInput, setUploadMultiCrmInput] = useState([])
  const [fileMultiCrmName, setFileMultiCrmName] = useState("")
  const [fileMultiCrmLength, setFileMultiCrmLength] = useState("")

  const uploadMultiCrmChange = async (e) => {
    if (e.target.files) {
      setUploadMultiCrmInput(e.target.files)
      var file = e.target.files
      setFileMultiCrmName(file[0].name)
      setFileMultiCrmLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadMultiCrmInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadMultiCrmInput(teamUploadValue)
          }
        })
      }
    }
  }
  //deliver buttons

  let deliverButtons = [
    {
      label: "Pre Deliverables",
      color:
        deliverTab === "Pre Deliverables"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Overall Deliverables",
      color:
        deliverTab === "Overall Deliverables"
          ? "btn btn-success"
          : "btn btn-warning",
    },
  ]
  const historySubmit = (e) => {
    e.preventDefault()
    const crmDeliver = {
      productionId: tatDetails.productionId,
      deliverableId: tatDetails.leadDeliverableId,
      tat: !isEmpty(tatData.tatDate) ? tatData.tatDate : "",
      link: !isEmpty(tatData.link) ? tatData.link : "",
      crmRemark: !isEmpty(tatData.remarks) ? tatData.remarks : "",
      crmAttachments:
        !isEmpty(tatAttachment) && tatAttachment.length > 0
          ? tatAttachment
          : [],
    }
    dispatch(quotationAction.updateCrmDeliver(crmDeliver))
    setTatModal(false)
    setTimeout(() => {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
      toast.success("CRM Deliverable Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  const submitCrm = () => {
    const crm_details = {
      notes: crmData.notes,
      menuMode: 1,
      attachments: uploadCrmInput,
      employeeId: crmEmployee.value,
      leadAssignDetail: [
        {
          leadId: crmAssignData.leadId,
          leadDelivarableId: [crmAssignData.leadDeliverableId],
        },
      ],
    }
    console.log(crm_details, "mycheck")
    dispatch(quotationAction.addCrmAssign(crm_details))
    setTimeout(() => {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
    }, 1000)
  }

  const crmLeadArray =
    !isEmpty(crmAssignDetails) && crmAssignDetails.length > 0
      ? crmAssignDetails.map((data) => {
          return {
            leadId: data.leadId ? data.leadId : "",
            leadDelivarableId: [data.leadDeliverableId],
          }
        })
      : []
  const submitMultiCrm = () => {
    const crm_details = {
      notes: multiCrmData.note,
      attachments: uploadMultiCrmInput,
      menuMode: 1,
      employeeId: multiEmployee.value,
      leadAssignDetail: crmLeadArray,
    }
    dispatch(quotationAction.addCrmAssign(crm_details))
    setTimeout(() => {
      dispatch(quotationAction.loadECDeliverableDetails(Id))
      setCrmAssignDetails([])
    }, 1000)
  }
  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <p className="quote-head">
          Deliverables Details
          <span className="quote-info">
            <i
              style={{ color: "grey" }}
              id="DeliverablesInfo"
              aria-hidden="true"
              className="fa fa-info-circle ms-1"
            ></i>
            <UncontrolledTooltip placement="right" target="DeliverablesInfo">
              Deliverables Details Description
            </UncontrolledTooltip>
          </span>
        </p>
        <Col md="12" lg="12" xl="12">
          <Nav className="nav">
            {deliverButtons.map((data, index) => {
              return (
                <button
                  key={index}
                  type="submit"
                  className={data.color}
                  style={{
                    marginRight: "20px",
                    marginTop: "10px",
                  }}
                  onClick={() => {
                    setDeliverTab(data.label)
                  }}
                >
                  {data.label}
                </button>
              )
            })}
          </Nav>
        </Col>
        {(() => {
          switch (deliverTab) {
            case "Pre Deliverables":
              return (
                <>
                  <Row className="quote-head-content">
                    <p className="quote-head">
                      Pre Deliverables
                      <span className="quote-info">
                        <i
                          style={{ color: "grey" }}
                          id="PreDeliverablesInfo"
                          aria-hidden="true"
                          className="fa fa-info-circle ms-1"
                        ></i>
                        <UncontrolledTooltip
                          placement="right"
                          target="PreDeliverablesInfo"
                        >
                          Pre Deliverables Description
                        </UncontrolledTooltip>
                      </span>
                    </p>
                  </Row>
                  <Col md="12" lg="12" xl="12" className="mt-3">
                    <PaginationProvider
                      pagination={paginationFactory(options)}
                      keyField="_id"
                      columns={columns}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          data={deliverDataTable}
                          columns={columns}
                          search
                          exportCSV
                        >
                          {(props) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row  ">
                                  <Col className="mb-3" md="4">
                                    <div className="d-flex flex-row ">
                                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <div
                                          className="position-relative mt-7"
                                          style={searchBarStyle || null}
                                        >
                                          <SearchBar {...props.searchProps} />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </div>{" "}
                                  </Col>

                                  <Col>
                                    <div
                                      style={{
                                        float: "right",
                                        marginRight: "10px",
                                      }}
                                    >
                                      {productSubmitButton ? (
                                        <Button
                                          className="btn btn-success text-nowrap"
                                          onClick={() => {
                                            setMultiProductModal(true)
                                            handleClearModal()
                                          }}
                                          style={{
                                            marginRight: "10px",
                                          }}
                                        >
                                          Product Lead Assign
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                      {teamSubmitButton ? (
                                        <Button
                                          className="btn btn-danger text-nowrap"
                                          onClick={() => {
                                            setMultiTeamModal(true)
                                            handleClearModal()
                                          }}
                                          style={{
                                            marginRight: "10px",
                                          }}
                                        >
                                          Team Assign
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                      {crmAssignButton ? (
                                        <Button
                                          className="btn btn-success text-nowrap"
                                          onClick={() => {
                                            setMultiCrmModal(true)
                                            handleClearModal()
                                          }}
                                          style={{
                                            marginRight: "10px",
                                          }}
                                        >
                                          CRM Assign
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                      <ExportCSVButton
                                        className="border float-right mx-10"
                                        style={{
                                          float: "right",
                                          backgroundColor: "#e40d8c",
                                          color: "#ffffff",
                                        }}
                                        {...props.csvProps}
                                      >
                                        Download{" "}
                                      </ExportCSVButton>{" "}
                                    </div>
                                  </Col>
                                  <Col>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      responsive
                                      striped={true}
                                      bordered={true}
                                      keyField="_id"
                                      columns={columns}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </Col>

                  {instructionsModal && (
                    <Modal size="xl" show={instructionsModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Instructions
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mt-3">
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Mode</th>
                                <th>Remarks</th>
                                <th>Created By</th>
                                <th>Created On</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(instructionsDetails) &&
                              instructionsDetails.length > 0 ? (
                                instructionsDetails.map((data, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{data.mode}</td>
                                      <td>{data.remarks}</td>
                                      <td>{data.InsertByName}</td>
                                      <td>
                                        {moment(data.createdAt).format(
                                          dateFormat
                                        )}
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr key={0}>
                                  <td className="text-align-center" colSpan={5}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setInstructionsModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {crmAttachmentModal && (
                    <Modal show={crmAttachmentModal} size="lg">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Deliverable Attachment
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="12" md="12" sm="12" xs="12">
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Sl.No</th>
                                  <th>Attachments</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(crmAttachmentsDetails) &&
                                crmAttachmentsDetails.length > 0 ? (
                                  crmAttachmentsDetails.map((item, index) => {
                                    const splitAttach = !isEmpty(item)
                                      ? item.split(".")
                                      : ""
                                    const attachExtension = !isEmpty(
                                      splitAttach
                                    )
                                      ? splitAttach.pop()
                                      : ""
                                    return (
                                      <>
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            {" "}
                                            {(item &&
                                              attachExtension === "jpeg") ||
                                            (item &&
                                              attachExtension === "jpg") ||
                                            (item &&
                                              attachExtension === "png") ? (
                                              <a
                                                onClick={() =>
                                                  window.open(item, "_blank")
                                                }
                                              >
                                                <span
                                                  style={{
                                                    textDecoration: "underline",
                                                    color: "#E40D8C",
                                                  }}
                                                >
                                                  View
                                                </span>
                                              </a>
                                            ) : (item &&
                                                attachExtension === "mp3") ||
                                              (item &&
                                                attachExtension === "m4a") ||
                                              (item &&
                                                attachExtension === "mp4") ? (
                                              <a href={item}>
                                                <audio controls>
                                                  <source
                                                    src={item}
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser does not support
                                                  the audio element.
                                                </audio>
                                              </a>
                                            ) : (
                                              ""
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  })
                                ) : (
                                  <>
                                    <tr key={0}>
                                      <td
                                        colSpan={2}
                                        className="text-align-center"
                                      >
                                        No record found
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={() => setCrmAttachmentModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {productAssignModal && (
                    <Modal size="xl" show={productAssignModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Product Lead
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="employee"
                              value={employee}
                              onChange={(e) => setEmployee(e)}
                              options={employeeOptions}
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>

                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="notes"
                              value={productData.notes}
                              onChange={(e) => handleNotes(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="attachmentModalFile"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => productUploadChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {attachFileLength ? attachFileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {attachFileName ? attachFileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setProductAssignModal(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setProductAssignModal(false)
                            productSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {teamAssignModal && (
                    <Modal size="xl" show={teamAssignModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Team
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="teamEmployee"
                              value={teamEmployee}
                              onChange={(e) => setTeamEmployee(e)}
                              options={employeeOptions}
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={teamData.note}
                              onChange={(e) => handleTeam(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="uploadModalInput"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => uploadModalChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {fileLength ? fileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {fileName ? fileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setTeamAssignModal(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setTeamAssignModal(false)
                            teamSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiProductModal && (
                    <Modal size="xl" show={multiProductModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Product Lead
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="multiProductEmployee"
                              value={multiProductEmployee}
                              onChange={(e) => setMultiProductEmployee(e)}
                              options={employeeOptions}
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiProductData.note}
                              onChange={(e) => handleMultiProduct(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="multiProductFile"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => multiProductChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {productFileLength ? productFileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {productFileName ? productFileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiProductModal(false)
                            setProductAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            multiProductSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiTeamModal && (
                    <Modal size="xl" show={multiTeamModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Team
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="multiTeamEmployee"
                              value={multiTeamEmployee}
                              onChange={(e) => setMultiTeamEmployee(e)}
                              options={employeeOptions}
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiTeamData.note}
                              onChange={(e) => handleMultiTeam(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="multiTeamFile"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => multiTeamChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {teamFileLength ? teamFileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {teamFileName ? teamFileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiTeamModal(false)
                            setTeamAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            teamMultipleSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {processStatusModal && (
                    <Modal size="xl" show={processStatusModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Process Status History
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Mode</th>
                                <th>Employee Name</th>
                                <th>Operation Status</th>
                                <th>Notes</th>
                                <th>Attachment</th>
                                <th>Created By</th>
                                <th>Created On</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(processHistoryDetails) &&
                              processHistoryDetails.length > 0 ? (
                                processHistoryDetails.map((data, index) => {
                                  const processStatus =
                                    !isEmpty(processStatusOptions) &&
                                    processStatusOptions.length > 0
                                      ? processStatusOptions.find(
                                          (_) =>
                                            _.value ===
                                            data.productionprocessstatus
                                        )?.label
                                      : "--"
                                  const createdOn = !isEmpty(data.createdOn)
                                    ? moment(data.createdOn)
                                        .subtract(5, "hours")
                                        .subtract(30, "minutes")
                                        .format(`${dateFormat} ${"hh:mm A"}`)
                                    : "--"
                                  const empName =
                                    data.employeName && data.employeCode
                                      ? data.employeCode +
                                        "-" +
                                        data.employeName
                                      : "--"
                                  const attachment = !isEmpty(data.attachment)
                                    ? data.attachment.map((m) => m).join()
                                    : ""
                                  const attachExtension = !isEmpty(attachment)
                                    ? attachment.split(".").pop()
                                    : ""
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{data.mode ? data.mode : "--"}</td>
                                      <td>{empName}</td>
                                      <td>{processStatus}</td>
                                      <td>{data.notes ? data.notes : "--"}</td>
                                      <td>
                                        {" "}
                                        {(attachment &&
                                          attachExtension === "jpeg") ||
                                        (attachment &&
                                          attachExtension === "jpg") ||
                                        (attachment &&
                                          attachExtension === "png") ? (
                                          <a
                                            onClick={() =>
                                              window.open(attachment, "_blank")
                                            }
                                          >
                                            <span
                                              style={{
                                                textDecoration: "underline",
                                                color: "#E40D8C",
                                              }}
                                            >
                                              View
                                            </span>
                                          </a>
                                        ) : (attachment &&
                                            attachExtension === "mp3") ||
                                          (attachment &&
                                            attachExtension === "m4a") ||
                                          (attachment &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachment}>
                                            <audio controls>
                                              <source
                                                src={attachment}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                      <td>
                                        {data.createdByName
                                          ? data.createdByName
                                          : "--"}
                                      </td>
                                      <td>{createdOn}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td className="text-align-center" colSpan={8}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setProcessStatusModal(false)}
                        >
                          Cancel
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {crmAssignModal && (
                    <Modal size="xl" show={crmAssignModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        CRM Assign
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="crmEmployee"
                              value={crmEmployee}
                              onChange={(e) => setCrmEmployee(e)}
                              options={employeeOptions}
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>

                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="notes"
                              value={crmData.notes}
                              onChange={(e) => handleCrmNotes(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>
                              <Input
                                type="file"
                                name="uploadCrmInput"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                multiple
                                onChange={(e) => uploadCrmChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {fileCrmLength ? fileCrmLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {fileCrmName ? fileCrmName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setCrmAssignModal(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setCrmAssignModal(false)
                            submitCrm()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiCrmModal && (
                    <Modal size="xl" show={multiCrmModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        CRM Assign
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="multiEmployee"
                              value={multiEmployee}
                              onChange={(e) => setMultiEmployee(e)}
                              options={employeeOptions}
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>

                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiCrmData.note}
                              onChange={(e) => handleMultiNotes(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>
                              <Input
                                type="file"
                                name="uploadMultiCrmInput"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                multiple
                                onChange={(e) => uploadMultiCrmChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {fileMultiCrmLength ? fileMultiCrmLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {fileMultiCrmName ? fileMultiCrmName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiCrmModal(false)
                            setCrmAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiCrmModal(false)
                            submitMultiCrm()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {tatModal && (
                    <Modal size="xl" show={tatModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Deliverable Update History
                      </Modal.Header>
                      <Modal.Body>
                        {tatUpdate && (
                          <Row className="mb-5">
                            <Col md="3" lg="3" xl="3" sm="12">
                              <div className="d-flex justify-content-between">
                                <Label
                                  className={"form-label"}
                                  htmlFor={"Date"}
                                >
                                  {"Tat Date"}
                                </Label>
                              </div>
                              <Input
                                type="date"
                                name="tatDate"
                                value={tatData.tatDate}
                                onChange={(e) => handleTatChange(e)}
                                placeholder="Enter Date"
                              />
                            </Col>
                            <Col md="3" lg="3" xl="3" sm="12">
                              <div className="d-flex justify-content-between">
                                <Label
                                  className={"form-label"}
                                  htmlFor={"link"}
                                >
                                  {"Link"}
                                </Label>
                              </div>
                              <Input
                                type="text"
                                name="link"
                                value={tatData.link}
                                onChange={(e) => handleTatChange(e)}
                                placeholder="Enter Link"
                              />
                            </Col>
                            <Col md="3" lg="3" xl="3" sm="12">
                              <div className="d-flex justify-content-between">
                                <Label
                                  className={"form-label"}
                                  htmlFor={"remarks"}
                                >
                                  {"Remarks"}
                                </Label>
                              </div>
                              <Input
                                type="textarea"
                                name="remarks"
                                value={tatData.remarks}
                                onChange={(e) => handleTatChange(e)}
                                placeholder="Enter Remarks"
                              />
                            </Col>
                            <Col md="3" lg="3" xl="3" sm="12">
                              <div className="d-flex justify-content-between">
                                <Label
                                  className={"form-label"}
                                  htmlFor={"Notes"}
                                >
                                  {"Attachment"}
                                </Label>
                              </div>
                              <Input
                                type="file"
                                name="tatAttachment"
                                onChange={(e) => tatAttachmentChange(e)}
                                placeholder="Attach the files"
                                multiple
                              />
                            </Col>
                          </Row>
                        )}
                        {tatView && (
                          <Row className="mt-3">
                            <Table>
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Mode</th>
                                  <th>Tat Date</th>
                                  <th>Link</th>
                                  <th>Remarks</th>
                                  <th>Attachment</th>
                                  <th>Created By</th>
                                  <th>Created On</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(operationHistoryDetails) &&
                                operationHistoryDetails.length > 0 ? (
                                  operationHistoryDetails.map((data, index) => {
                                    const tatDate = data.tat
                                      ? moment(data.tat).format(dateFormat)
                                      : "--"
                                    const attachment = !isEmpty(data.attachment)
                                      ? data.attachment.map((m) => m).join()
                                      : ""

                                    const attachExtension = !isEmpty(attachment)
                                      ? attachment.split(".").pop()
                                      : ""
                                    const createdOn = !isEmpty(data.createdOn)
                                      ? moment(data.createdOn)
                                          .subtract(5, "hours")
                                          .subtract(30, "minutes")
                                          .format(`${dateFormat} ${"hh:mm A"}`)
                                      : "--"
                                    return (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{data.mode ? data.mode : "--"}</td>
                                        <td>{tatDate}</td>
                                        <td>{data.link ? data.link : "--"}</td>
                                        <td>
                                          {data.remarks ? data.remarks : "--"}
                                        </td>
                                        <td>
                                          {" "}
                                          {(attachment &&
                                            attachExtension === "jpeg") ||
                                          (attachment &&
                                            attachExtension === "jpg") ||
                                          (attachment &&
                                            attachExtension === "png") ? (
                                            <a
                                              onClick={() =>
                                                window.open(
                                                  attachment,
                                                  "_blank"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#E40D8C",
                                                }}
                                              >
                                                View
                                              </span>
                                            </a>
                                          ) : (attachment &&
                                              attachExtension === "mp3") ||
                                            (attachment &&
                                              attachExtension === "m4a") ||
                                            (attachment &&
                                              attachExtension === "mp4") ? (
                                            <a href={attachment}>
                                              <audio controls>
                                                <source
                                                  src={attachment}
                                                  type="audio/mpeg"
                                                />
                                                Your browser does not support
                                                the audio element.
                                              </audio>
                                            </a>
                                          ) : (
                                            "--"
                                          )}
                                        </td>
                                        <td>
                                          {data.createdByName
                                            ? data.createdByName
                                            : "--"}
                                        </td>
                                        <td>{createdOn}</td>
                                      </tr>
                                    )
                                  })
                                ) : (
                                  <tr>
                                    <td
                                      className="text-align-center"
                                      colSpan={8}
                                    >
                                      No Records Found...
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Row>
                        )}
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setTatModal(false)}
                        >
                          Cancel
                        </Button>
                        {tatUpdate ? (
                          <Button
                            type="submit"
                            variant="secondary"
                            className={"btn btn-success"}
                            data-bs-dismiss="modal"
                            onClick={(e) => historySubmit(e)}
                          >
                            update
                          </Button>
                        ) : (
                          ""
                        )}
                      </Modal.Footer>
                    </Modal>
                  )}
                  <ToastContainer
                    position="top-right"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </>
              )
            case "Overall Deliverables":
              return (
                <Col>
                  <OverallDeliverables />
                </Col>
              )
          }
        })()}
      </Row>
    </React.Fragment>
  )
}
EcDeliverableDetails.propTypes = {
  dispatch: PropTypes.func,
  record_quotation_details: PropTypes.array,
  record_event_details: PropTypes.array,
  deliverable_details: PropTypes.array,
  instructions: PropTypes.array,
  checklist_details: PropTypes.array,
  service_details: PropTypes.array,
  sales_details: PropTypes.array,
  qc_history: PropTypes.array,
  location: PropTypes.array,
  service_total_account: PropTypes.array,
  quotationList: PropTypes.array,
  clientProfile: PropTypes.array,
  recordArray: PropTypes.array,
  loginAccess: PropTypes.array,
  modeMenu: PropTypes.any,
  quotationRecordsMetaData: PropTypes.object,
  records: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EcDeliverableDetails)
)
